import Const from '@/const'
import { cloneDeep } from 'lodash'
import moment from 'moment'

export default {
  namespaced: true,
  state: {},
  mutations: {},

  actions: {
    /** 見積取得 */
    find({ dispatch }, data) {
      const request = {
        url: Const.API_URL.MITUMORI,
        params: data,
      }
      return dispatch('http/get', { ...request }, { root: true }).then(
        (v) => v.data
      )
    },

    /** 見積追加 */
    add({ dispatch }, data) {
      const request = {
        url: `${Const.API_URL.MITUMORI}/add`,
        params: data,
      }
      return dispatch('http/post', { ...request }, { root: true })
    },

    /** 見積編集 */
    edit({ dispatch }, data) {
      const request = {
        url: `${Const.API_URL.MITUMORI}/edit`,
        params: data,
      }
      return dispatch('http/post', { ...request }, { root: true })
    },

    /** 見積削除 */
    delete({ dispatch }, id) {
      const request = {
        url: `${Const.API_URL.MITUMORI}/delete/${id}`,
      }
      return dispatch('http/get', { ...request }, { root: true })
    },

    /** 見積メール送信 */
    send({ dispatch }, data) {
      const request = {
        url: `${Const.API_URL.MITUMORI}/send`,
        params: data,
      }
      return dispatch('http/post', { ...request }, { root: true })
    },

    /** 見積履歴追加 */
    addRireki({ dispatch }, data) {
      const request = {
        url: `${Const.API_URL.MITUMORI_RIREKI}/add`,
        params: data,
      }
      return dispatch('http/post', { ...request }, { root: true }).then(
        (v) => v.data
      )
    },

    /** 見積履歴編集 */
    editRireki({ dispatch }, data) {
      const request = {
        url: `${Const.API_URL.MITUMORI_RIREKI}/edit`,
        params: data,
      }
      return dispatch('http/post', { ...request }, { root: true })
    },

    /** 見積料金API */
    ryokin({ dispatch }, formData) {
      const data = cloneDeep(formData)
      let hShikiCd = null
      if (!data.hikitori.TOROKUBAYO_KO_ID) {
        hShikiCd = data.hikitori.SHIKI_CD || data.hikitori.SHIKU_CD
      } else if (
        typeof data.hikitori.TOROKUBAYO_KO_ID === 'string' &&
        data.hikitori.TOROKUBAYO_KO_ID.includes('common_landmark-')
      ) {
        // 引取先で登録済みの場所から共通ランドマークを選択した場合
        hShikiCd = data.hikitori.TOROKUBAYO_KO_ID.split('-')[1]
        data.hikitori.TOROKUBAYO_KO_ID = null
        data.hikitori.PLACE_TYPE = Const.RYOKIN_API_AREA_TYPE.LANDMARK
        data.hikitori.IS_PERSONAL = 0
      }

      let nShikiCd = null
      if (!data.nosya.TOROKUBAYO_KO_ID) {
        nShikiCd = data.nosya.SHIKI_CD || data.nosya.SHIKU_CD
      } else if (
        typeof data.nosya.TOROKUBAYO_KO_ID === 'string' &&
        data.nosya.TOROKUBAYO_KO_ID.includes('common_landmark-')
      ) {
        // 納車先で登録済みの場所から共通ランドマークを選択した場合
        nShikiCd = data.nosya.TOROKUBAYO_KO_ID.split('-')[1]
        data.nosya.TOROKUBAYO_KO_ID = null
        data.nosya.PLACE_TYPE = Const.RYOKIN_API_AREA_TYPE.LANDMARK
        data.nosya.IS_PERSONAL = 0
      }

      const isMeihen = Number(data.MEIHEN_FLG)
      let params = {
        is_meihen: isMeihen ? 1 : 0,
        jyuchu_shiki_code: data.JYUCYU_SHIKI_CD ? data.JYUCYU_SHIKI_CD : '',
        car_type:
          [1].indexOf(Number(data.syaryo.SYARYO_TYPE_KBN)) !== -1
            ? 0
            : Number(data.syaryo.SYARYO_TYPE_KBN),
        is_jiso:
          data.syaryo.JISOU_KBN === null || Number(data.syaryo.JISOU_KBN) === 1
            ? 1
            : 0,
        is_fudo: Number(data.syaryo.JYOTAI_FLG) === 1 ? 0 : null,
        car_hight: data.syaryo.SYARYO_TAKASA
          ? `${Number(data.syaryo.SYARYO_TAKASA) * 10}mm`
          : null,
        fr_placetype: data.hikitori.PLACE_TYPE,
        fr_registid: data.hikitori.TOROKUBAYO_KO_ID || null,
        fr_shiki_cd: hShikiCd,
        fr_is_privatehouse: data.hikitori.IS_PERSONAL
          ? Number(data.hikitori.IS_PERSONAL)
          : 0,
        to_placetype: data.nosya.PLACE_TYPE,
        to_registid: data.nosya.TOROKUBAYO_KO_ID || null,
        to_shiki_cd: nShikiCd,
        to_is_privatehouse: data.nosya.IS_PERSONAL
          ? Number(data.nosya.IS_PERSONAL)
          : 0,
        option: null,
      }

      // 土曜日判定
      const isSatarday = data.nosya.NOSYA_KIBOU_BI
        ? moment(data.nosya.NOSYA_KIBOU_BI).day() === 6
        : false

      // オプション料金設定
      if (
        Number(data.syaryo.ETC_SETUP_FLG) ||
        Number(data.syaryo.MEIHEN_SYAKOSYO_DAIKO_KBN) === 3 ||
        Number(data.syaryo.MEIHEN_KIBO_NUMBER_DAIKO_FLG) ||
        isSatarday
      ) {
        params['option'] = {
          etc: Number(data.syaryo.ETC_SETUP_FLG),
          syako: Number(data.syaryo.MEIHEN_SYAKOSYO_DAIKO_KBN) === 3,
          kibou_num: Number(data.syaryo.MEIHEN_KIBO_NUMBER_DAIKO_FLG),
          is_kei: Number(data.syaryo.MEIHEN_KEI_FLG),
          to_hope_day: isMeihen && isSatarday,
        }
      }

      const request = {
        url: Const.API_URL.RYOKIN,
        params: params,
      }
      return dispatch('http/post', { ...request }, { root: true }).then(
        (v) => v.data
      )
    },

    /** オプション料金取得 */
    option({ dispatch }) {
      const request = {
        url: Const.API_URL.MITUMORI_OPTION,
      }
      return dispatch('http/post', { ...request }, { root: true }).then(
        (v) => v.data
      )
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/mitumori.js